import React from 'react';

const mainColor = '#4299e1';

const SvgWebsite = () => (
  <svg
    id="bafe8b78-4c8e-4247-a450-f8fe2d5894b0"
    data-name="Layer 1"
    xmlns="http://www.w3.org/2000/svg"
    width="1025.5"
    height="720.71343"
    viewBox="0 0 1025.5 720.71343"
    style={{ width: '100%', height: '100%' }}
  >
    <title>slider</title>
    <ellipse cx="521.81083" cy="689.11669" rx="503.68917" ry="31.59674" fill="#3f3d56" />
    <path
      d="M125.94114,747.782c11.54993,21.41984,36.063,30.61492,36.063,30.61492s5.787-25.53335-5.763-46.95319-36.063-30.61492-36.063-30.61492S114.39121,726.36216,125.94114,747.782Z"
      transform="translate(-87.25 -89.64329)"
      fill="#3f3d56"
    />
    <path
      d="M133.87984,740.735c20.85238,12.54548,28.88328,37.46426,28.88328,37.46426s-25.77747,4.57854-46.62984-7.96694S87.25,732.76808,87.25,732.76808,113.02747,728.18955,133.87984,740.735Z"
      transform="translate(-87.25 -89.64329)"
      fill={mainColor}
    />
    <rect x="101.71748" y="88.34303" width="825.31765" height="26.25696" fill="#f2f2f2" />
    <polygon
      points="927.035 681.247 101.717 681.247 101.717 504.122 192.831 425.792 927.035 370.122 927.035 681.247"
      fill={mainColor}
    />
    <circle cx="123.80271" cy="101.08451" r="6.79546" fill={mainColor} />
    <circle cx="145.88794" cy="101.08451" r="6.79546" fill={mainColor} />
    <circle cx="167.97317" cy="101.08451" r="6.79546" fill={mainColor} />
    <polygon
      points="101.717 503.715 927.035 369.266 927.035 114.6 101.717 114.6 101.717 503.715"
      fill="#fff"
    />
    <path
      d="M921.88932,649.923q-33.42034-5.662-64.281-9.725l8.13329-15.76933c-2.74256-.95255-14.79194,8.07808-14.79194,8.07808l10.67364-45.77458c-13.79337,1.66343-20.80642,48.40207-20.80642,48.40207l-15.41077-15.802,7.46085,17.76562c-62.968-7.41544-117.34916-10.165-163.09014-10.26406l6.9613-13.4969c-2.74256-.95255-14.79194,8.07808-14.79194,8.07808l10.67364-45.77458c-13.79337,1.66343-20.80642,48.40207-20.80642,48.40207l-15.41077-15.802,7.90222,18.8167a916.11979,916.11979,0,0,0-93.75366,6.36833c7.041-21.02573,30.95992-41.02287,30.95992-41.02287-18.2667,5.43279-27.84858,14.53661-32.85538,23.024a368.67139,368.67139,0,0,1,21.30917-127.38076S532.20827,570.20755,537.026,625.358l.57623,9.79313c-32.00911,4.58328-48.10185,9.35173-48.10185,9.35173Z"
      transform="translate(-87.25 -89.64329)"
      fill="#3f3d56"
    />
    <rect x="161.2789" y="263.98372" width="230.47032" height="9.29316" fill="#3f3d56" />
    <rect x="161.2789" y="284.42867" width="230.47032" height="9.29316" fill="#3f3d56" />
    <rect x="161.2789" y="304.87362" width="78.06253" height="9.29316" fill="#3f3d56" />
    <circle cx="488.08549" cy="663.61226" r="9.0658" fill="#f2f2f2" />
    <circle cx="514.3763" cy="664.51884" r="9.0658" fill="#f2f2f2" />
    <circle cx="540.66711" cy="665.42542" r="9.0658" fill="#f2f2f2" />
    <circle cx="514.45943" cy="664.51884" r="7.25264" fill="#3f3d56" />
    <circle cx="773.31468" cy="133.2431" r="83.97916" fill="#ff6584" />
    <path
      d="M919.01933,324.04621c16.53357,112.83138-44.77152,162.0517-127.5078,174.17533q-2.88274.42242-5.74708.77638-5.76987.71873-11.46029,1.14394c-75.447,5.65488-139.53577-27.25732-154.912-132.19026C603.47977,259.359,722.18743,101.98009,731.11128,90.322c.00909-.00133.00909-.00133.01694-.01188.33885-.44412.51294-.66683.51294-.66683S902.4871,211.224,919.01933,324.04621Z"
      transform="translate(-87.25 -89.64329)"
      fill={mainColor}
    />
    <path
      d="M783.52985,481.76157l43.57456-84.58626L784.6234,490.186l1.14105,8.81193q-5.76987.71873-11.46029,1.14394l-10.6371-113.74241-.1739-.86675.07676-.18037L762.568,374.604l-67.54934-77.10356,66.54392,69.08889.46941,2.24177-8.03732-85.93677L693.95505,201.788l58.42265,66.03361L731.11128,90.322l-.06793-.59112.08487.57924,19.66064,139.55482,38.82143-62.15574-37.26414,74.194,9.9486,76.54606,33.0938-79.70672L763.76525,329.702l5.53253,42.56339,48.663-111.33L771.2201,387.1148Z"
      transform="translate(-87.25 -89.64329)"
      fill="#3f3d56"
    />
  </svg>
);

export default SvgWebsite;
